import { createEntityAdapter, createReducer } from '@reduxjs/toolkit';
import { SmscModel } from '../../models/smscModel';
import { smscFetchAllFailureAction, smscFetchAllRequestAction, smscFetchAllSuccessAction } from './smscActions';
import { convertVersionableIdToString } from '../../types/versionableId';
import { SmscStateModel } from './smscStateModel';

export const smscAdapter = createEntityAdapter<SmscModel>({
  selectId: smscModel => convertVersionableIdToString(smscModel.id),
});

const initialState: SmscStateModel = smscAdapter.getInitialState({
  loading: false,
  errors: [],
});

export const smscReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(smscFetchAllRequestAction, (state) => {
      state.loading = true;
      state.errors = [];
    })
    .addCase(smscFetchAllSuccessAction, (state, action) => {
      state.loading = false;
      smscAdapter.setAll(state, action.payload);
    })
    .addCase(smscFetchAllFailureAction, (state, action) => {
      state.loading = false;
      state.errors = [...state.errors, action.payload];
    });
});
